import { seriesStatus } from '@/pages/dashboard/constants'
import { installmentsStatus } from '@/pages/timeline/sections/timeline/timelineSections/enrolled/constants/index'
import moment from 'moment';
import numeral from "numeral";
import { countryList } from '@/assets/countryList';
import { countryWithRegions } from "@/assets/countryWithRegions"
import { allQueryParam } from "@/constants/urlPaths"
import { themes } from '@/constants/colors_v2';
import { maxScreenWidthForDesktop } from '@/pages/watch/main/constants';

export const getTimePassedSince = (isoDate: string): string => {
    const now = new Date();
    const target = new Date(isoDate);
    // debugger
    if (now >= target) {
        return '';
    }

    const diffMs = target.getTime() - now.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
    // const diffMinutes = Math.floor((diffMs / (1000 * 60)) % 60);

    let result = '';
    if (diffDays > 0) result += `${diffDays} day${diffDays !== 1 ? 's' : ''} `;
    if (diffHours > 0) result += `${diffHours} hour${diffHours !== 1 ? 's' : ''} `;
    // if (diffMinutes > 0) result += `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''}`;

    return result.trim();
}

export const getTimePassedSince2 = (isoDateStr: string) => {
    const nowUtc = new Date().getTime(); // UTC timestamp
    const targetUtc = new Date(isoDateStr).getTime(); // ISO string in UTC

    if (nowUtc >= targetUtc) {
        return "show";
    }

    const diffMs = targetUtc - nowUtc;
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    return `${diffDays} day${diffDays > 1 ? 's' : ''}.`;
}


export const numberToNumberSt = (n: number): string => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}


export const isDueDatePassed = (dueDateISO: string): boolean => {
    return moment(dueDateISO).isBefore(moment(), 'day');
}

export const makeFirstLetterCapsAndRemoveUnderScore = (text: string): string => {
    if (!text) return '';

    const withSpaces = text.replace(/_/g, ' ');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}


export const allSeriesCompleted = (series: any) => {
    const allCompleted = series.every(
        (item: { seriesStatus: string; seriesCompletedAt: any; }) => item.seriesStatus === seriesStatus.completed && item.seriesCompletedAt
    );

    if (!allCompleted) return null;

    const latestDate = series.reduce((latest: any, item: any) => {
        const current = new Date(item.seriesCompletedAt);
        return current > latest ? current : latest;
    }, new Date(0));

    return latestDate.toISOString();
}


export const checkAnyInstallmentUnPaidHelper = (installmentSchedule: any) => {
    const installments = installmentSchedule
    let unpaid = false
    if (installments && installments.length > 0) {
        const unPaidDetails = installments.find((item: { status: any; }) => item.status === installmentsStatus.pending);
        if (unPaidDetails && Object.entries(unPaidDetails).length > 0) {
            unpaid = true
        }
    }
    // return false // testing
    return unpaid
}


export const capitalizeFirstLetter = (str: string | null | undefined): string => {
    if (!str) {
        return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const lowercaseFirstLetter = (str: string | null | undefined): string => {
    if (!str) {
        return "";
    }
    return str.charAt(0).toLowerCase() + str.slice(1);
};


export const getCountryByValue = (searchValue: string) => {
    return countryList.find(country => country.value === searchValue);
};


export const formatNumberInputWithSpaceAfter5Numbers = (value: any) => {
    // 1. Remove all non-digit characters
    const cleanedValue = value.replace(/\D/g, '');

    // 2. Apply the desired format (5 digits + space + 5 digits)
    let formatted = '';
    if (cleanedValue.length > 0) {
        formatted += cleanedValue.substring(0, 5); // First 5 digits
    }
    if (cleanedValue.length > 5) {
        formatted += ' ' + cleanedValue.substring(5, 10); // Space + next 5 digits
    }

    // 3. Limit the total length to 11 characters (10 digits + 1 space)
    return formatted.substring(0, 11);
};

export const undo_formatNumberInputWithSpaceAfter5Numbers = (formattedString: string | null | undefined): string => {
    if (!formattedString) {
        return "";
    }
    // Use a regular expression to replace any non-digit character (\D) with an empty string.
    // The 'g' flag ensures that all occurrences are replaced, not just the first one.
    return formattedString.replace(/\D/g, '');
};


export const removeLeadingPlus = (inputString: string | null | undefined): string => {
    if (!inputString) {
        return ""; // Handle null, undefined, or empty strings
    }
    // Check if the string starts with '+'
    if (inputString.startsWith('+')) {
        // Return the substring starting from the second character
        return inputString.substring(1);
    }
    // If it doesn't start with '+', return the original string
    return inputString;
};



export const getRegionsByCountryValue = (countryValue: string) => {
    // Use the find() method to get the first country object that matches the value
    const country = countryWithRegions.find(c => c.value === countryValue);

    // If a country is found, return its regions array, otherwise return null or an empty array
    if (country) {
        return country.regions;
    } else {
        return null; // Or return [] if you prefer an empty array for no match
    }
}



export const generateYearsObjectsList = () => {
    const currentYear = new Date().getFullYear(); // Gets the current year (e.g., 2025)
    const startYear = 1950;
    const yearsObjects = [];

    for (let year = startYear; year <= currentYear; year++) {
        yearsObjects.push({
            value: year, // The numerical year
            label: year  // The numerical year as a label
        });
    }

    return yearsObjects;
}


export const dataURLtoBlob = (dataurl: any) => {
    try {
        // --- Input Validation ---
        if (typeof dataurl !== 'string' || !dataurl.includes(',')) {
            console.error("Invalid data URL format: Expected a string containing a comma.", dataurl);
            return { status: false };
        }

        // Split the data URL into its parts: [0] "data:image/png;base64", [1] "iVBORw0KGgoAAAA..."
        const arr = dataurl.split(',');

        // Ensure both parts exist
        if (arr.length < 2) {
            console.error("Data URL missing Base64 data part.", dataurl);
            return { status: false };
        }

        // Extract the MIME type from the first part, e.g., "image/png"
        // The regex /:(.*?);/ matches everything between ":" and ";"
        const mimeMatch = arr[0].match(/:(.*?);/);

        if (!mimeMatch || mimeMatch.length < 2) {
            console.error("Could not extract MIME type from data URL.", arr[0]);
            return { status: false };
        }
        const mime = mimeMatch[1];

        // Decode the Base64 string (the second part of the array)
        // atob() is used for Base64 decoding, but can throw an error for invalid Base64
        let bstr;
        try {
            bstr = atob(arr[1]);
        } catch (e) {
            console.error("Failed to decode Base64 string. Invalid Base64 data.", e);
            return { status: false };
        }

        // Get the length of the decoded string
        const n = bstr.length;

        // Create a Uint8Array to hold the binary data
        const u8arr = new Uint8Array(n);

        // Iterate through the decoded string and populate the Uint8Array
        // Each character's charCodeAt() gives its ASCII value, which becomes the byte.
        for (let i = 0; i < n; i++) { // Changed while (n--) to for loop for safer iteration
            u8arr[i] = bstr.charCodeAt(i);
        }

        // Create a new Blob object from the Uint8Array and the extracted MIME type
        const blob = new Blob([u8arr], { type: mime });

        return { status: true, blob: blob };

    } catch (error) {
        // Catch any unexpected errors during the process
        console.error("An unexpected error occurred during data URL to Blob conversion:", error);
        return { status: false };
    }
};



export const isValidImageDataURI = (input: string) => {
    return (
        typeof input === 'string' &&
        input.trim() !== '' &&
        input.startsWith('data:image/')
    );
}


export const convertImageToBase64UsingCanvas = (url: string) => {
    return new Promise((resolve, reject) => {
        try {
            const img = new Image();
            img.crossOrigin = 'anonymous'; // must be set before `src`

            img.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx: any = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL(); // defaults to image/png
                resolve(dataURL);
            };

            img.onerror = reject;
            img.src = url;
        } catch (e) {
            console.log(e)
        }
    });
}

export const convertImageToBase64UsingCanvas_v2 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};



export const formatNumber = (value: number): string => {
    return numeral(value).format("0.[0]a"); // Examples: 1.5k, 2m, 3.2b
};



export const isPublicVideo = (videoObj: any) => {
    let isPublic = videoObj.isPublic ? videoObj.isPublic : false
    if (hasQueryParam(allQueryParam.series)) {
        isPublic = false
    }
    return isPublic
}


export const hasQueryParam = (key: string) => {
    const params = new URLSearchParams(window.location.search);
    const result = params.has(key);
    return result
}



export const isUrlPath = (searchPath: string) => {
    let pathFound = false
    const path = window.location.pathname;
    if (path === searchPath) {
        pathFound = true
    }
    return pathFound
}


export const findCourseById = (courses: any[], targetCourseId: string) => {
    return courses.find(course => course.courseId === targetCourseId) || null;
}


export const getCurrentDate = () => {
    const currentDateISO = new Date().toISOString();
    return currentDateISO;
}


export const scrollToAVideoInSeriesList = (divId: any) => {
    const element = document.getElementById(divId)

    const container = document.getElementById("seriesListMain");

    if (element && container) {
        const width = window.innerWidth;
        if (width > maxScreenWidthForDesktop) {
            const top = element.offsetTop - container.offsetTop;
            container.scrollTo({
                top,
                behavior: "smooth"
            });
        } else {
            document.getElementById(divId)?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    } else {
        console.log("no id found scrollToASectionOfDocument")
    }
}


export const getSystemTheme = () => {
    let theme: any = themes.light
    if (window && window.matchMedia) {
        let theme_ = window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (theme_) {
            theme = themes.dark
        }
    }
    return theme
}



export const generateInvoiceFileName = (order: any) => {
    try {
        // Get course details
        const courses = order?.courses || [];
        const coursesMnemonic = order?.coursesMnemonic || "";
        const paymentStructure = order?.paymentStructure || "full";
        const orderType = order?.orderType || "course";
        const installmentNumber = order?.installmentNumber || 0;
        const createdAt = order?.createdAt;
        const durationDetails = order?.durationDetails || {};

        // Format date
        const formattedDate = moment(createdAt)
            .utcOffset(330) // set to +05:30 IST
            .format("Do, MMM YYYY");

        // Determine course name/names
        let courseName = "";

        if (courses.length === 1) {
            // Single course - use the course title
            courseName = courses[0]?.title || "Course";
        } else if (courses.length > 1) {
            // Multiple courses - use mnemonic names separated by ' + '
            courseName = coursesMnemonic || "Courses";
        } else {
            // Fallback
            courseName = "Course";
        }

        // Handle course extension order type
        if (orderType === "courseExtension") {
            const extensionDays = durationDetails?.duration || 0;
            courseName += ` Course Extension ${extensionDays} days`;
        }

        // Determine installment text or remaining balance text
        let installmentText = "";
        if (paymentStructure === "installment" && installmentNumber > 0) {
            // Convert number to ordinal (1st, 2nd, 3rd, etc.)
            const ordinalSuffixes: any = {
                1: "First",
                2: "Second",
                3: "Third",
                4: "Fourth",
                5: "Fifth",
                6: "Sixth",
                7: "Seventh",
                8: "Eighth",
                9: "Ninth",
                10: "Tenth",
            };

            installmentText = ordinalSuffixes[installmentNumber] || `${installmentNumber} th`;
            installmentText += " Installment";
        } else if (paymentStructure === "remainingBalance") {
            installmentText = "Full Balance payment";
        }

        // Build filename
        let filename = courseName;

        if (installmentText) {
            filename += ` ${installmentText}`;
        }

        filename += ` ${formattedDate}.PDF`;

        return filename;
    } catch (error) {
        console.error("Error generating invoice filename:", error);
        const date = moment(order?.createdAt || new Date())
            .utcOffset(330)
            .format("Do, MMM YYYY");
        return `Invoice ${date}.PDF`;
    }
};


export const addCurrentThemeClassToEle = (currentTheme: any, className: any) => {
    const classThemeSeprator = "_theme_"
    return currentTheme + classThemeSeprator + className
}

export const getColorCodeForTagAsPerTheme = (currentTheme: any, currentColorCode: any, themeNum: any) => {
    if (currentTheme === themes.dark) {
        const newColorCode = themes.dark + "_" + currentColorCode + "_theme" + themeNum
        return newColorCode
    } else {
        return currentColorCode
    }
}




export const sanitizeUrlsForBudketOldLinks = (user: any, url: any) => {
    const s3Base = url;

    // Fields to check in root object
    const rootFields = [
        "passportPhoto",
        "marksheetOrDegreeCert",
        "aadharOrIdProof"
    ];

    // Fields to check in bssForm
    const bssFormFields = [
        "aadharCard",
        "panCard",
        "otherDocs",
        "signature"
    ];

    const cleanValue = (value: any) => {
        if (
            value === null ||
            value === "null" ||
            (typeof value === "string" && value.includes(s3Base))
        ) {
            return null;
        }
        return value;
    };

    // Root-level fields
    rootFields.forEach(field => {
        user[field] = cleanValue(user[field]);
    });

    // bssForm fields
    if (user.bssForm) {
        bssFormFields.forEach(field => {
            user.bssForm[field] = cleanValue(user.bssForm[field]);
        });
    }

    return user;
}




export const detectPlatform = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        return 'ios';
    }

    if (/android/i.test(userAgent)) {
        return 'android';
    }

    return 'web';
};

export const isIOS = () => detectPlatform() === 'ios';
export const isAndroid = () => detectPlatform() === 'android';



export const oldPaymentGatewaysToNewOne = (currentPaymentGateway: any) => {
    if (currentPaymentGateway == null || currentPaymentGateway === '') {
        return currentPaymentGateway
    }
    const normalized = String(currentPaymentGateway).trim().toLowerCase()
    // Legacy Razorpay-family gateways → IDFC
    const oldPaymentGateways = ['razorpay', 'eazypay', 'axis']
    const defaultPaymentGateway = 'idfc'
    if (oldPaymentGateways.includes(normalized)) {
        return defaultPaymentGateway
    }
    return normalized
}



export const handleRedirectToUserWebPageLoginPage = (msg: string, showAlert: boolean, url: any) => {
    console.log("handleRedirectToUserWebPageLoginPage ", msg)
    if (typeof window === "undefined" || !url) return
    // My Learning embeds this app. Navigating window.top sends the whole site
    // to /login, and the login page then sends anyone who still has a session
    // cookie to home — so a dashboard API error looks like a logout.
    if (window.self !== window.top) return
    window.location.href = url
}


